import { Injectable } from "@angular/core";
import { HttpService } from "src/app/core";

@Injectable({
  providedIn: "root",
})
export class ReportsService extends HttpService {
  protected override get baseUrl(): string {
    return "report/";
  }

  getreportdata(body: any) {
    return this.post({ APIName: "getreportdata/", body, showAlert: true });
  }

  getvisitpeakhours(body: any) {
    return this.post({ APIName: "getvisitpeakhours/", body, showAlert: true });
  }

  exportvisitpeakhours(body: any) {
    return this.post<Blob>({
      APIName: "exportvisitpeakhours/",
      body,
      responseType: "blob" as "json",
    });
  }

  getdelaypayment(body: any) {
    return this.post({ APIName: "getdelaypayment/", body, showAlert: true });
  }

  getstatisticsvisitorreport(body: any) {
    return this.post({ APIName: "getstatisticsvisitorreport/", body, showAlert: true });
  }
}
